import CreateResourceInteractor from "../../core/interactor/app/crud/CreateResourceInteractor";
import Constants from "../common/Constants";
import { ICourtCaseConnectionType } from "../model/CourtCaseConnectionType";
import CourtCaseConnectionTypeMapper from "../service/CourtCaseConnectionTypeMapper";
import CourtCaseConnectionTypeParamMapper from "../service/CourtCaseConnectionTypeParamMapper";

export default class CreateCourtCaseConnectionTypeInteractor {
  private createResource: CreateResourceInteractor<ICourtCaseConnectionType>;

  constructor({ createResource }: any) {
    this.createResource = createResource;
  }

  async execute(model: ICourtCaseConnectionType) {
    return this.createResource.execute(
      `${Constants.courtCasesPath}/connection-types`,
      CourtCaseConnectionTypeMapper,
      CourtCaseConnectionTypeParamMapper,
      model
    );
  }
}
